import React from 'react'
import { Icon } from 'react-icons-kit'
import { ic_room_service } from 'react-icons-kit/md/ic_room_service'
import { ic_local_airport } from 'react-icons-kit/md/ic_local_airport'
import { ic_event_seat } from 'react-icons-kit/md/ic_event_seat'
import { ic_local_dining } from 'react-icons-kit/md/ic_local_dining'
import { ic_spa } from 'react-icons-kit/md/ic_spa'
import { ic_local_bar } from 'react-icons-kit/md/ic_local_bar'
import { ic_business } from 'react-icons-kit/md/ic_business'

// Map service names to icons
const getServiceIcon = (serviceName) => {
  const name = serviceName.toLowerCase()

  if (name.includes('lounge')) return ic_event_seat
  if (name.includes('dining') || name.includes('restaurant'))
    return ic_local_dining
  if (name.includes('spa') || name.includes('massage')) return ic_spa
  if (name.includes('bar')) return ic_local_bar
  if (name.includes('business')) return ic_business
  if (name.includes('airport') || name.includes('transfer'))
    return ic_local_airport

  return ic_room_service // default icon
}

export default ({ service, onServiceClick }) => {
  const handleClick = () => {
    if (service && onServiceClick) onServiceClick(service)
  }

  const icon = getServiceIcon(service.name)

  return (
    <button
      onClick={handleClick}
      className="group relative bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 p-6 flex flex-col items-center justify-center min-h-[200px] hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
    >
      <div className="mb-4 text-primary-600 group-hover:text-primary-700 transition-colors">
        <Icon icon={icon} size={64} />
      </div>
      <div className="text-center">
        <span className="text-gray-800 font-medium text-lg leading-tight">
          {service.name}
        </span>
      </div>
    </button>
  )
}
